import {
  MAX_BULK_RETURN_IDS,
  ReturnActionIdSchema,
} from "@redotech/redo-return-core-common/return-actions/registry";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * Starts one bulk run and returns as soon as the workflow exists. The payload
 * is opaque on the wire: the handler parses it with the action's own
 * payloadSchema, so a new action needs no branch here and payloads must be
 * plain JSON.
 */
export const startBulkReturnAction = {
  name: "startBulkReturnAction" as const,
  input: z.object({
    action: ReturnActionIdSchema,
    payload: z.unknown(),
    /** Only the returns the bar judged eligible; the run judges again. */
    returnIds: z.array(zExt.objectId()).min(1).max(MAX_BULK_RETURN_IDS),
  }),
  output: z.object({ runId: z.string() }),
};
